import Axios from 'axios'
import { loadStripe } from '@stripe/stripe-js';
import {parseTranslations} from './middlewars/translations';

const config = {
  GOOGLE_MAPS_API_KEY: 'AIzaSyDQ_7sO-ZxjAZSHQXCUtVdQdHeWIytBy5I',
  stripe_countries: [
    'LR', 'IQ', 'TR',
    'GQ', 'GN', 'KG',
    'MM', 'BY', 'LB',
    'CD', 'ZW',
  ],
}
// console.log(app.$store);
//
config.API = Axios.create({
  baseURL: process.env['VUE_APP_SERVICE_API_URL'] + '/api',
});

config.API.interceptors.request.use(function (config) {

    const locale = app.$store.getters['user/data'].language ? app.$store.getters['user/data'].language : 'en';
    // console.log(app.$store.getters['user/data'].language, locale);
    config.headers['Locale'] =  locale;
    return config;
});


config.API.interceptors.response.use(res => {
  if (res.data) {
    res.data = parseTranslations(res.data);
  }

  return res;
}, err => {
  console.error(err.response.data, err.response.status);

  if (err.response.status == 401 && err.response.data == 'Unauthorized') {
    app.$store.commit('user/logout');
    app.$router.push({ path: '/' });
  } else if (err.response.status == 403) {
    app.$notify({
      title: err.response.data.err,
      type: 'error',
      group: 'notices',
    });
  }

  // if(err.response.status >= 500) {
    // app.$notify({
    //   title: 'Server error',
    //   type: 'error',
    //   group: 'notices',
    // });
  // }

  return Promise.reject(err);
});

async function installStripe() {
  config.stripe = await loadStripe(process.env['VUE_APP_STRIPE_PK']);
}
installStripe();

export default config;
